/**
 * Sprint T-16.1 · Automation Center · HTTP service layer.
 *
 * 14 thin wrappers over /api/automation/* endpoints (T-16 backend).
 * Zero business logic · zero data transformation · axios only.
 *
 * Consumers: `hooks/useAutomation.js` React Query hooks.
 */
import { api } from "../lib/api";

const BASE = "/automation";

export const automationApi = {
  // 1. Engine health + introspection
  info: () => api.get(`${BASE}/info`),

  // 2-6. Jobs CRUD + actions
  listJobs: () => api.get(`${BASE}/jobs`),
  getJob: (jobId) => api.get(`${BASE}/jobs/${encodeURIComponent(jobId)}`),
  runJob: (jobId, { input, idempotency_key } = {}) =>
    api.post(`${BASE}/jobs/${encodeURIComponent(jobId)}/run`, {
      input: input || {},
      idempotency_key: idempotency_key || undefined,
    }),
  pauseJob: (jobId, until = null) =>
    api.post(`${BASE}/jobs/${encodeURIComponent(jobId)}/pause`, { until }),
  resumeJob: (jobId) =>
    api.post(`${BASE}/jobs/${encodeURIComponent(jobId)}/resume`),

  // 7-8. Executions
  listExecutions: ({ job_name, status, limit = 50, skip = 0 } = {}) =>
    api.get(`${BASE}/executions`, { params: { job_name, status, limit, skip } }),
  getExecution: (id) => api.get(`${BASE}/executions/${encodeURIComponent(id)}`),

  // 9-11. DLQ
  listDlq: ({ limit = 50, skip = 0 } = {}) =>
    api.get(`${BASE}/dlq`, { params: { limit, skip } }),
  retryDlq: (dlqId) =>
    api.post(`${BASE}/dlq/${encodeURIComponent(dlqId)}/retry`),
  discardDlq: (dlqId) =>
    api.post(`${BASE}/dlq/${encodeURIComponent(dlqId)}/discard`),

  // 12. Events
  listEvents: ({ event_name, limit = 50, skip = 0 } = {}) =>
    api.get(`${BASE}/events`, { params: { event_name, limit, skip } }),

  // 13. Notification intents
  listIntents: ({ status, limit = 50, skip = 0 } = {}) =>
    api.get(`${BASE}/notifications/intents`, { params: { status, limit, skip } }),

  // 14. Metrics
  metrics: () => api.get(`${BASE}/metrics`),
};

export default automationApi;
